module.exports = __webpack_public_path__ + "static/media/client26.a70be0a6.webp";